export const PLATFORM = { GoogleMeet: "google_meet", ZoomWeb: "zoom_web", MicrosoftTeams: "microsoft_teams" } as const;
export type Platform = (typeof PLATFORM)[keyof typeof PLATFORM];
export const PLATFORMS: readonly Platform[] = [PLATFORM.GoogleMeet, PLATFORM.ZoomWeb, PLATFORM.MicrosoftTeams];
export const PLATFORM_LABEL: Record<Platform, string> = {
  [PLATFORM.GoogleMeet]: "Google Meet",
  [PLATFORM.ZoomWeb]: "Zoom",
  [PLATFORM.MicrosoftTeams]: "Microsoft Teams",
};

export const MEETING_STATUS = { Live: "live", Ended: "ended" } as const;
export type MeetingStatus = (typeof MEETING_STATUS)[keyof typeof MEETING_STATUS];
export const MEETING_STATUSES: readonly MeetingStatus[] = [MEETING_STATUS.Live, MEETING_STATUS.Ended];
export const MEETING_STATUS_LABEL: Record<MeetingStatus, string> = {
  [MEETING_STATUS.Live]: "Live",
  [MEETING_STATUS.Ended]: "Ended",
};

export const OVERVIEW_STATUS = { Ready: "ready", Generating: "generating", Failed: "failed", None: "none" } as const;
export type OverviewStatus = (typeof OVERVIEW_STATUS)[keyof typeof OVERVIEW_STATUS];
export const OVERVIEW_STATUSES: readonly OverviewStatus[] = [
  OVERVIEW_STATUS.Ready,
  OVERVIEW_STATUS.Generating,
  OVERVIEW_STATUS.Failed,
  OVERVIEW_STATUS.None,
];
export const OVERVIEW_STATUS_LABEL: Record<OverviewStatus, string> = {
  [OVERVIEW_STATUS.Ready]: "Ready",
  [OVERVIEW_STATUS.Generating]: "Generating",
  [OVERVIEW_STATUS.Failed]: "Failed",
  [OVERVIEW_STATUS.None]: "Not generated",
};

export const MEETING_SORT = { Newest: "newest", Oldest: "oldest", Segments: "segments" } as const;
export type MeetingSort = (typeof MEETING_SORT)[keyof typeof MEETING_SORT];
export const MEETING_SORTS: readonly MeetingSort[] = [MEETING_SORT.Newest, MEETING_SORT.Oldest, MEETING_SORT.Segments];
export const MEETING_SORT_LABEL: Record<MeetingSort, string> = {
  [MEETING_SORT.Newest]: "Newest first",
  [MEETING_SORT.Oldest]: "Oldest first",
  [MEETING_SORT.Segments]: "Most segments",
};

export function isOneOf<T extends string>(values: readonly T[], value: unknown): value is T {
  return typeof value === "string" && (values as readonly string[]).includes(value);
}
